import React, { useRef, useState } from "react";
import { Grid, Typography, Box, Backdrop } from "@material-ui/core";
import { useFormik } from "formik";
import moment from "moment";
import CommonButton from "src/components/CommonButton/CommonButton";
import { useStyles } from "../style";
import * as Yup from "yup";
import CommonLoader from "src/components/Loader/CommonLoader";
import CommonTextFieldMonthYear from "src/components/CommonTextFieldForDate/CommonTextFieldMonthYear";

export function MonthlySOAReport() {
  const classes = useStyles();
  const [loader, setLoader] = useState<boolean>(false);
  const monthlyDatePickerRef: any = useRef(null);

  const validationSchema = Yup.object().shape({
    month: Yup.string().required("This field is required"),
  });

  const formik = useFormik({
    initialValues: {
      month: moment(new Date(new Date())).format("MM/YYYY"),
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const monthYear = { month: moment(new Date(`01/${values.month}`)).format("DD-MM-YYYY") };
      setLoader(true);
      const idToken = localStorage.getItem("token");
      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${idToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(monthYear),
      };

      fetch(`${process.env.REACT_APP_API_URL}/get-payment-soa-report`, requestOptions)
        .then((response) => {
          if (response.status === 200) return response.blob();
          else throw response;
        })
        .then((data) => {
          const newBlob = new Blob([data]);

          // Download code
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(
            new File([newBlob], `Monthly-SOA-Report ${moment().format("DD-MMM-YY, hh:mm A")}.xlsx`)
          );
          link.download = `Monthly-SOA-Report ${moment().format("DD-MMM-YY, hh:mm A")}.xlsx`;
          link.click();
          setLoader(false);
        })
        .catch((error) => {
          setLoader(false);
          // throw error;
        });
    },
  });

  return (
    <>
      <Backdrop className={classes.backdrop} open={loader}>
        <CommonLoader />
      </Backdrop>
      <Grid container direction="row" justifyContent="space-between" style={{ paddingTop: "10px" }}>
        <Typography className={classes.pageSubHeading}>Monthly SOA Report</Typography>
        <Grid item xs={12} className={classes.outer} container direction="row">
          <Grid item xs={12} md={5}>
            <CommonTextFieldMonthYear
              cssClassName="customTextField"
              label={"Monthly"}
              name={"month"}
              datePickerRef={monthlyDatePickerRef}
              value={formik.values.month}
              enableTime={false}
              onChange={(e: any) => {
                formik.setFieldValue("month", e);
              }}
              maxDate={moment().format("YYYY-MM-DD")}
              minDate={moment(new Date("2020-01-01")).format("YYYY-MM-DD")}
              required={true}
            />
          </Grid>
          <Grid item xs={12} md={5}>
            <Box
              sx={{
                marginLeft: { xs: 0, md: "10px" },
                marginTop: { xs: "10px", md: 0 },
              }}
            ></Box>
          </Grid>
          <Grid item xs={12} md={2}>
            <Box
              sx={{
                marginLeft: { xs: 0, md: "10px" },
                marginTop: { xs: "10px", md: 0 },
              }}
            >
              <CommonButton
                isGreen
                cssClass={classes.checkButton}
                onClick={() => formik.submitForm()}
              >
                Download Report
              </CommonButton>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
